import React from "react";
import { Box } from "../../styledSystemUtilities";
import { BusinessCardsHero } from "../../Atoms/assets";
import { CopyWriting, Pen, Printer, Shipping, Strategy } from "../../Atoms";
import { Dimensions, GrayBackground, IconContainer, PricingNotes, SellingPoint } from "../../Molecules";
import { ProfitHeader } from "../../Molecules/PopupComponents";

export const BusinessCards = ({ setPopup }) => {
    return (
        <Box width={"100%"}>
            <ProfitHeader setPopup={setPopup} Hero={BusinessCardsHero} />
            <GrayBackground>
                <SellingPoint
                    header={"Your brand in every detail"}
                    body={
                        "Business cards matter when you want to make a great impression. We’ve designed hundreds of them over the years and apply high design standards to creative thinking."
                    }
                />
                <Dimensions bold={"2” x 3.5”"} light={"– 14 pt. cardstock"} />
                <SellingPoint
                    header={"Why Ascent for your business cards?"}
                    body={
                        "• Better brand Integration\n" +
                        "• High-end, original design \n" +
                        "• We specialize in dental – It’s all we do\n" +
                        "• Smart strategy\n" +
                        "• Professional copywriting\n" +
                        "• It’s easier – We’re a one-stop-shop\n" +
                        "• Timely delivery"
                    }
                    lineHeight={"24px"}
                />
                <IconContainer name={"What's Included"}>
                    <Pen name={"Design"} />
                    <Strategy name={"Strategy"} fill={"balticBlue"} />
                    <CopyWriting name={"Copywriting"} fill={"balticBlue"} />
                    <Printer name={"Printing"} />
                    <Shipping name={"Shipping"} />
                </IconContainer>
            </GrayBackground>
            <PricingNotes>
                Print materials are purchased on a per-item basis and must be paid in full. We offer the choice of a
                1-time payment or 12 payments at a monthly interest rate of 12%.
            </PricingNotes>
        </Box>
    );
};
